import {
  AutocompleteProps,
  // eslint-disable-next-line no-restricted-imports
  Autocomplete as BeyondAutocomplete,
  createGlobalStyle,
  styled,
} from '@zeiss/beyond-online-react';

/**
 * Override the styles for the Popover component used by the Autocomplete
 * to match the documented design specs
 *
 * @see {@link https://beyond.zeiss.com/document/9#/form/autocomplete}
 */
const PopoverStyles = createGlobalStyle`
  /*
    The popover is poisitioned relative to the trigger (the input field).
    React-aria positions it 8px below the trigger.
    Here, we override that to position it exactly at the bottom of the input field.
  */
  div[data-placement='bottom'] {
    margin-top: -8px !important;
  }

  /*
    If the Autocomplete is placed at the bottom of the page, the popover
    will be positioned above the trigger (the input field).
    Here we override that to position it exactly above the input label, which is
    24px above the input field.
  */
  div[data-placement='top'] {
    margin-bottom: 24px !important;
  }
`;

/**
 * This wrapper allows us use CSS to target the elements of the autocomplete
 * component from Beyond.
 *
 * This is necessary because Beyond only passes the remaining `...props` to the
 * input element instead of the parent wrapper element.
 */
const Wrapper = styled.div`
  /*
    AutCompleteWrapper from beyond
    We unset the height because it affects spacing between other on-page elements
  */
  & > div {
    height: unset;
  }
`;

export const Autocomplete = (args: AutocompleteProps) => {
  return (
    <Wrapper>
      <PopoverStyles />
      <BeyondAutocomplete {...args} />
    </Wrapper>
  );
};
